const Unauthorized = () => (
  <div style={{ textAlign: "center", marginTop: "10%" }}>
    <h1>403 - Unauthorized</h1>
    <p>You do not have permission to access this page.</p>
  </div>
);

export default Unauthorized;
